export default "__VITE_ASSET__BuAVdDHC__";